<template>
  <div>
    <PageTitleVue
      :sub-title="'Altere a ficha cadastral do seu colaborador'"
    >
      Atualizar dados

      <template #b-action>
        <Create
          @click="router.back()"
          :icon="PhArrowLeft"
          :label="'Voltar'"
          :menu-active="'Colaboradores'"
        />
      </template>
    </PageTitleVue>

    <Form
      id="form-fields"
      :descriptionTitle="'Dados pessoais'"
    >
      <Transition mode="out-in">
        <section :key="personalPermissions" v-if="personalPermissions == 'PERSONALIZADO'">
          <PermissionsForm :create="false" />
        </section>
      </Transition>
      <Password
        :create="false"
        :descriptionTitle="'Senha de acesso'"
        :descriptionSubTitle="'Altere a senha de acesso de seu colaborador'"
      />

      <ShiftForm
        :descriptionTitle="'Horarios de atendimento'"
        :descriptionSubTitle="'Informe os turnos que esse colaborador estará disponivel para serviços'"
      />

      <div class="w-full flex justify-center mt-4">
        <CreateButton
          @click="updateCollaborator"
          :icon="'fa-solid fa-user-plus'"
          :label="'Atualizar'"
        />
      </div>
    </Form>

    <!-- <FloatBackPage /> -->
  </div>
</template>

<script setup>
import FloatBackPage from '@/components/Buttons/FloatBackPage.vue'
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import CollabService from '../services/collab.service'
import Create from '@/components/Buttons/Create.vue'
import PermissionsForm from './PermissionsForm.vue'
import Password from './PasswordForm.vue'
import Form from '../layouts/Form.vue'
import * as yup from '@/validator'
import router from '@/router'
import { dataCollab } from '../store'
import { storeApp } from '@/store'
import { setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { onBeforeMount, onMounted, computed } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { useRoute } from 'vue-router'
import { PhArrowLeft } from '@phosphor-icons/vue'
import ShiftForm from './ShiftForm.vue'

const collab_id = useRoute().params.id
const appStore = storeApp
const store = dataCollab
const personalPermissions = computed(() => store.getters.getPermissionType)

const form = yup.object().shape({
  name: yup.string().required().label('Nome').min(3).max(100),
  phone: yup.string().nullable().label('Celular').max(20),
  email: yup.string().required().label('Email').max(100),
  permission_type: yup.string().nullable().label('Permissões').max(50)
})

const password = yup.object().shape({
  password: yup.object().shape({
    old: yup.string().min(5, 'Inválido').required('Por favor informe a senha anterior'),
    newPass: yup.string().required('É necessário informar a nova senha').min(5, 'Deve ter no mínimo 5 caracteres'),
    confirm: yup.string().oneOf([yup.ref('newPass'), null], 'As senhas devem ser iguais').required('Por favor confirme a nova senha')
  })
})

onBeforeMount(async () => {
  store.commit('reset')
  appStore.state.loading = true
  await getCollab()
  await permissions()
  appStore.state.loading = false
})

async function getCollab () {
  store.commit('reset')
  await CollabService.getCollabById(collab_id)
    .then(res => {
      store.commit('updateCollabFields', res.data)

      store.state.userPermissions = res.data.permissions
      store.state.role = res.data.permissions
      store.state.permission_type = res.data.permission_type

      store.dispatch('setCollabSettings', res.data.turno)
    }).catch(err => {
      toast(
        'Erro',
        'Algo deu arrado ao buscar dados do colaborador',
        'error'
      )
    })
}

// lista todas as permissões
async function permissions () {
  await CollabService.getPermissions()
    .then(res => {
      store.state.permissions = res.data
    }).catch(err => {
      toast(
        'Erro',
        'Algo deu arrado ao buscar dados do funcionário',
        'error'
      )
    })
}

async function updateCollaborator () {
  // validação dos campos de login
  const validatePassword = undefined
  if (store.state.password.newPass) { validatePassword = (await validateFormField(password, store.state)) }

  if (validatePassword && validatePassword.length > 0) {
    setFormFieldsError(validate)
    appStore.state.loading = false
    return
  }

  const data = Object.assign({}, store.state)

  delete data.password.deleted_at
  delete data.userPermissions
  delete data.permissions
  delete data.haircuts
  delete data.password.confirm
  delete data.password.old
  delete data.deleted_at
  delete data.indicated_by
  delete data.settings

  appStore.state.loading = true

  const validate = (
    await validateFormField(form, store.state)
  )

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.state.loading = false
    return
  }

  if ( // se caso exista uma foto, remova e troque pela nova
    store.state.image &&
    typeof store.state.image === 'object' &&
    typeof store.state.imgPath === 'string' &&
    store.state.imgPath !== '[]'
  ) {
    await CollabService.editImage(
      store.state.image,
      store.state.imgPath
    )
      .then((res) => {
        data.imgPath = res.data
        data.image = res.data
      })
      .catch((err) => {
        toast(
          'Aviso',
          'Algo deu errado ao subir arquivo!',
          'error'
        )
      })
  } else if ( // adicione uma nova foto
    store.state.image &&
    typeof store.state.image !== 'string'
  ) {
    await CollabService.saveImage(store.state.image)
      .then((res) => {
        data.imgPath = res.data
        data.image = res.data
      })
      .catch((err) => {
        toast(
          'Aviso',
          'Algo deu errado ao subir arquivo!',
          'error'
        )
      })
  } else { // passa o caminho da imagem
    // store.state.image = store.state.imgPath
    data.image = store.state.imgPath
  }

  delete data.imgPath

  await CollabService.editCollaborator(store.state.id, data)
    .then(res => {
      appStore.state.loading = false
      if (res.data.success) {
        toast(
          'Sucesso',
          res.data.success,
          'success'
        )
      }
    })
    .catch(err => {
      appStore.state.loading = false
      toast(
        'Erro',
        err.response.data.error,
        'error'
      )
    })
}

</script>

<style lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
